import { Routes } from '@angular/router';
import { Chat } from './views/chat/chat';
import { Login } from './views/login/login';
import { authGuard } from './guards/auth-guard';
import { OpeningScreenComponent } from './views/opening-screen/opening-screen.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: OpeningScreenComponent,
  },
  {
    path: "chat",
    component: Chat,
    canActivate: [authGuard]
  },
  {
    path: 'auth/login',
    component: Login,
  },
];
